import React, { Component, Fragment } from 'react';
import { Button, Row, Card, CardBody } from 'reactstrap';
import IntlMessages from '../../helpers/IntlMessages';
import { Colxx, Separator } from '../../components/common/CustomBootstrap';
import Breadcrumb from '../../containers/navs/Breadcrumb';
import { AxiosAPI, getUserID, getGroupID } from '../../helpers/AxiosAPI';
import { gAPI_Users_By_Id } from '../../constants/APIs';
class BlankPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: undefined,
    };
  }
  componentDidMount() {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    })
      .then((res) => {
        //console.log('123', res.data);
        this.setState({ userData: res.data });
      })
      .catch((err) => console.error(err));
  }
  render() {
    const { userData } = this.state;
    return (
      <Fragment>
        <h5>
          {' '}
          {userData && userData.firstName
            ? `Hello, ${userData.firstName}!`
            : 'Hello!'}
        </h5>
        <div className="d-flex justify-content-start mt-2">
          <h1>
            <IntlMessages id="dashboards.quickstartwithai" />
          </h1>
        </div>
        <div
          className="d-flex justify-content-start mb-2"
          style={{ marginTop: '-1rem' }}
        >
          <p>
            <IntlMessages id="dashboards.fastestpathtoautomation" />{' '}
          </p>
        </div>
        <div className="row">
          <div className="mb-4 col-12">
            <Card style={{ borderRadius: '50px' }}>
              <CardBody>
                <div style={{ padding: '2rem', paddingTop: '1rem' }}>
                  <div className="my-3">
                    <div
                      className="w-60 w-sm-100 active"
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        (window.location.href = '/app/dashboards/analytics')
                      }
                    >
                      <h5
                        style={{ color: 'var(--theme-color-1)' }}
                        className="list-item-heading mb-1 color-theme-1"
                      >
                        <IntlMessages id="dashboards.insightsthatempower" />
                      </h5>
                      <p className="mb-2 text-muted text-small">
                        <IntlMessages id="menu.dashboards" />
                      </p>
                      <p className="mb-4 text-small">
                        <IntlMessages id="dashboards.chatbotinsights" />
                      </p>
                    </div>
                  </div>
                  <Separator></Separator>
                  <div className="my-3">
                    <div
                      className="w-40 w-sm-100 active"
                      style={{ cursor: 'pointer' }}
                    >
                      <h5
                        style={{ color: 'var(--theme-color-1)' }}
                        className="list-item-heading mb-1 color-theme-1"
                      >
                        <IntlMessages id="dashboards.trainchatbot" />
                      </h5>
                      <p className="mb-1 text-muted text-small">
                        <IntlMessages id="menu.propinfo" />
                      </p>
                      <p className="mb-4 text-small">
                        <IntlMessages id="dashboards.trainchatbotproperty" />.
                      </p>
                    </div>
                  </div>
                  <Separator></Separator>
                  <div className="my-3">
                    <div
                      className="w-40 w-sm-100 active"
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        (window.location.href = '/app/pages/propinfo/forms')
                      }
                    >
                      <h5
                        style={{ color: 'var(--theme-color-1)' }}
                        className="list-item-heading mb-1 color-theme-1"
                      >
                        <IntlMessages id="dashboards.automatewithforms" />
                      </h5>
                      <p className="mb-1 text-muted text-small">
                        <IntlMessages id="menu.formbuilder" />
                      </p>
                      <p className="mb-4 text-small">
                        <IntlMessages id="dashboards.createcustomforms" />.
                      </p>
                    </div>
                  </div>
                  <Separator></Separator>
                  <div className="my-3">
                    <div
                      className="w-40 w-sm-100 active"
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        (window.location.href =
                          '/app/pages/integration/channels')
                      }
                    >
                      <h5
                        style={{ color: 'var(--theme-color-1)' }}
                        className="list-item-heading mb-1 color-theme-1"
                      >
                        <IntlMessages id="dashboards.addaichatbottoyourwebsite" />
                      </h5>
                      <p className="mb-1 text-muted text-small">
                        <IntlMessages id="menu.settings" /> |{' '}
                        <IntlMessages id="property-info.webWidget" /> |{' '}
                        <IntlMessages id="dashboards.chatbots" />
                      </p>
                      <p className="mb-4 text-small">
                        <IntlMessages id="dashboards.customizewebwidget" />.
                      </p>
                    </div>
                  </div>
                  <Separator></Separator>
                  <div className="my-3">
                    <div
                      className="w-40 w-sm-100 active"
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        (window.location.href = '/app/pages/propinfo/services')
                      }
                    >
                      <h5
                        style={{ color: 'var(--theme-color-1)' }}
                        className="list-item-heading mb-1 color-theme-1"
                      >
                        <IntlMessages id="dashboards.inroomdigitalcompendium" />
                      </h5>
                      <p className="mb-1 text-muted text-small">
                        <IntlMessages id="virtual-front.guest-service-add-on-upsells" />
                      </p>
                      <p className="mb-4 text-small">
                        <IntlMessages id="dashboards.inroomqrcode" />
                      </p>
                    </div>
                  </div>
                  <Separator></Separator>
                  <div className="my-3">
                    <div
                      className="w-40 w-sm-100 active"
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        window.open('https://help.myma.ai/en/', '_target')
                      }
                    >
                      <h5
                        style={{ color: 'var(--theme-color-1)' }}
                        className="list-item-heading mb-1 color-theme-1"
                      >
                        <IntlMessages id="dashboards.support" />
                      </h5>
                      <p className="mb-1 text-muted text-small">
                        <IntlMessages id="dashboards.helpcenter" /> |{' '}
                        <IntlMessages id="menu.chat" />
                      </p>
                      <p className="mb-4 text-small">
                        <IntlMessages id="dashboards.searchfaqintegrations" />.
                        <IntlMessages id="dashboards.asklivechat" />
                      </p>
                    </div>
                  </div>
                  <Separator></Separator>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default BlankPage;
